const initialState = {
    loading: null,
    preview: {},
    previewStatus: {},
    master: {},
    masterStatus: {},
    mastersLibrary: [],
    taskMeta: {},
    originalTracks: {},
    uploadedData: {},
    cleanAudio: {},
    saveCleanedAudio: {},
    mixPreview: {},
    mixMetaData: {},
    mixedLibrary: {},
    lastActiveGoal: null,
    ongoingProcesses: [],
    mixProcessState: null,
    stemsData: {},
    uploadedFiles: [],
    mixReportId: null,
};

const audioEngineerReducers = (state = initialState, action) => {
    switch (action.type) {
        case 'STARTPREVIEW':
            return { ...state, loading: true };

        case 'PREVIEWFAIL':
            return { ...state, loading: null };

        case 'STARTMASTER':
            return { ...state, loading: true };

        case 'MASTERFAIL':
            return { ...state, loading: null };

        case 'STARTMASTERSLIBRARY':
            return { ...state, loading: true };

        case 'MASTERSLIBRARYFAIL':
            return { ...state, loading: null };

        case 'PREVIEWDATA':
            return { ...state, loading: null, preview: action.preview };

        case 'PREVIEWDATASTATUS':
            return { ...state, loading: null, previewStatus: action.previewStatus };

        case 'MASTERDATA':
            return { ...state, loading: null, master: action.master };

        case 'MASTERDATASTATUS':
            return { ...state, loading: null, masterStatus: action.masterStatus };

        case 'MASTERSLIBRARYDATA':
            return { ...state, loading: null, mastersLibrary: action.mastersLibrary };

        case 'TASKMETADATA':
            return { ...state, loading: null, taskMeta: action.taskMeta };

        case 'ORIGINALTRACKDATA':
            return { ...state, loading: null, originalTracks: action.originalTracks };

        case 'UPLOADDATA':
            return {
                ...state,
                loading: null,
                uploadedData: action.uploadedData,
            };

        case 'UPDATE_UPLOAD_STATUSES': {
            if (!Array.isArray(state.uploadedData?.data)) return state;

            return {
                ...state,
                uploadedData: {
                    ...state.uploadedData,
                    data: state.uploadedData.data.map(item => {
                        const updated = action.payload.find(s => s._id === item._id);
                        return updated ? { ...item, ...updated } : item;
                    }),
                },
            };
        }

        case 'CLEAR_UPLOAD_DATA':
            return {
                ...state,
                uploadedData: {},
            };

        case 'CLEANAUDIODATA':
            return { ...state, loading: null, cleanAudio: action.cleanAudio };

        case 'SAVECLEANEDAUDIO':
            return { ...state, loading: null, saveCleanedAudio: action.saveCleanedAudio };

        case 'MIXPREVIEWDATA':
            return { ...state, loading: null, mixPreview: action.mixPreview };

        case 'MIXTRACKMETADATA':
            return { ...state, loading: null, mixMetaData: action.mixMetaData };

        case 'MIXEDLIBRARYDATA':
            return { ...state, loading: null, mixedLibrary: action.mixedLibrary };

        case 'SET_LAST_ACTIVE_GOAL':
            return { ...state, lastActiveGoal: action.lastActiveGoal };

        case 'SET_ONGOING_PROCESS': {
            try {
                const p = action.process || {};
                const id = p.id || (p.taskIds ? p.taskIds.join('|') : JSON.stringify(p));
                const filtered = state.ongoingProcesses.filter(proc => proc.id !== id);
                return {
                    ...state,
                    ongoingProcesses: [...filtered, { ...p, id }],
                };
            } catch (e) {
                return state;
            }
        }

        case 'UPDATE_ONGOING_PROCESS': {
            try {
                const { processIdOrTaskIds, statusUpdate } = action;
                const updated = state.ongoingProcesses.map(proc => {
                    const matchById = proc.id && proc.id === processIdOrTaskIds;
                    const matchByTasks =
                        Array.isArray(proc.taskIds) &&
                        Array.isArray(processIdOrTaskIds) &&
                        proc.taskIds.some(t => processIdOrTaskIds.includes(t));
                    return matchById || matchByTasks ? { ...proc, ...statusUpdate } : proc;
                });
                return { ...state, ongoingProcesses: updated };
            } catch (e) {
                return state;
            }
        }

        case 'UPDATE_UPLOAD_STATUSES': {
            if (!Array.isArray(state.uploadedData?.data)) return state;

            return {
                ...state,
                uploadedData: {
                    ...state.uploadedData,
                    data: state.uploadedData.data.map(item => {
                        const updated = action.payload.find(s => s._id === item._id);
                        return updated ? { ...item, ...updated } : item;
                    }),
                },
            };
        }

        case 'CLEAR_ONGOING_PROCESS':
            return {
                ...state,
                ongoingProcesses: state.ongoingProcesses.filter(p => p.id !== action.processId),
            };

        case "UPDATE_MIX_PROCESS_STATE":
            return {
                ...state,
                mixProcessState: action.payload,
            };

        case "STEMSMETADATA":
            return {
                ...state,
                stemsData: action.payload,
            };

        case "UPLOADFILEDATA":
            return {
                ...state,
                uploadedFiles: action.payload,
            };

        case "MIXREPORTID":
            return {
                ...state,
                mixReportId: action.payload,
            };

        default:
            return state;
    }
};

export default audioEngineerReducers;